import type { PropsWithChildren } from 'react';

import { cn } from '../../lib/utils';

interface SectionHeadingProps extends PropsWithChildren {
  title: string;
  description?: string;
  className?: string;
}

export function SectionHeading({ title, description, className, children }: SectionHeadingProps): JSX.Element {
  return (
    <div className={cn('space-y-3', className)}>
      <h2 className="text-balance text-2xl font-semibold tracking-tight text-[color:var(--color-text)] sm:text-3xl">{title}</h2>
      {description ? <p className="max-w-3xl text-pretty text-sm leading-relaxed text-[color:var(--color-muted)] sm:text-base">{description}</p> : null}
      {children}
    </div>
  );
}
